module.exports = __webpack_public_path__ + "img/pic_xiaomisteptwoone_1.2f7066cf.png";